<template>
	<span class="icon">
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
			<g><path d="M500,990C229.8,990,10,770.2,10,500C10,229.8,229.8,10,500,10c270.2,0,490,219.8,490,490C990,770.2,770.2,990,500,990z M500,56.7C255.5,56.7,56.7,255.5,56.7,500c0,244.5,198.9,443.3,443.3,443.3S943.3,744.5,943.3,500C943.3,255.5,744.5,56.7,500,56.7z"/><path d="M348.3,220l420,280l-420,280V220z"/></g>
		</svg>
	</span>	
</template>

<script>
	export default {
		name: "PauseIcon"
	}
</script>

<style scoped>

.icon {
	fill: #fff;
	width: 1.5rem;
	z-index: 1;
	display: block;
	margin: 0;
}

</style>




// WEBPACK FOOTER //
// src/icons/PlayIcon.vue